<template>
  <v-chip
    v-if="enabled"
    small
    label
    class="auto-extension-badge font-weight-bold"
    :class="{ 'auto-extension-badge--compact': compact }"
    :title="compact ? '自動延長' : undefined"
  >
    <v-icon
      :left="!compact"
      x-small
      class="auto-extension-badge__icon"
    >
      {{ icons.mdiAutorenew }}
    </v-icon>
    <template v-if="!compact">
      自動延長
    </template>
  </v-chip>
</template>

<script>
import { mdiAutorenew } from '@mdi/js'

export default {
  props: {
    // 自動延長が有効な卓（会計まで何度でも自動延長する）。
    // 複数回延長するため「済」状態は持たず、ONの間つねに「自動延長」を表示する。
    enabled: {
      type: Boolean,
      default: false,
    },
    // 幅の狭いフロアレイアウトの卓カード向け。アイコンのみ表示し、文言はtitle（ホバー）で補う
    compact: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      icons: { mdiAutorenew },
    }
  },
}
</script>

<style lang="scss" scoped>
// NOTE: color-pack無効のため `color="deep-purple accent-2"` は効かない（無色チップになる）。
//   フロア一覧で一目で気づけるよう、紫系の配色をCSS変数＋独自クラスで当てる
.auto-extension-badge.v-chip {
  --auto-extension-accent: #7c4dff;

  background-color: var(--auto-extension-accent) !important;
  border-color: var(--auto-extension-accent) !important;
  color: #fff !important;
}

.auto-extension-badge__icon.v-icon {
  color: #fff !important;
  caret-color: #fff !important;
}

// アイコンのみのコンパクト表示（狭い卓カードで残り時間等を圧迫しないため）
.auto-extension-badge--compact.v-chip {
  padding: 0 4px;
  min-width: 0;
  flex: 0 0 auto;
}
</style>
